import * as Blockly from 'blockly/core';
import 'blockly/python';

Blockly.Blocks['basket_aggregation'] = {
    init: function () {

        this.appendDummyInput("basket_input")
            .appendField("Basket")
            .appendField(new Blockly.FieldDropdown([
            ["SUM","sum"],
            ["AVERAGE","average"], 
            ["MIN","min"], 
            ["MAX","max"]]), "basket_aggregator");
  
        this.appendStatementInput("indicators");
        this.setStyle("dashboards");
        this.setPreviousStatement(true, null);
        this.setNextStatement(true, null);
    },
   
  }